import React, { useEffect, useState } from "react";
import loadingIcon from "../assets/images/loading.gif";
import { IArticleData } from '../models/get-article.model';
import { IPoliticAdapterResponse } from "../models/get-politic.model";
import { getArticles } from "../services/api/article.service";
import { SaveUserViewPolitic } from "../services/api/userPolitic.service";
import { SendPoliticEmail } from "../services/sendEmail";

interface ModalProps {
    politic: IPoliticAdapterResponse;
    onHandleAccept: () => void;
}

export const ModalArticles = ({ politic, onHandleAccept }: ModalProps) => {

    const [articleList, setArticleList] = useState<IArticleData[]>([])
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const getArticleList = async () => {
        await getArticles({ politic_id: politic.id })
            .then(res => {
                setArticleList(res?.response ?? [])
            })
    }

    const saveUserPolitic = async () => {
        setIsLoading(true);

        await SaveUserViewPolitic({ politic_id: politic.id })
            .then(res => {
                if (res.status) {
                    onHandleAccept();
                    if (res.complete && res.data) {
                        SendPoliticEmail();
                    }
                }
            })
            .finally(() => {
                setIsLoading(false);
            })
    }

    useEffect(() => {
        getArticleList();
    }, [politic])
    return (
        <>
            {
                isLoading && (
                    <div className="loading_all_page">
                        <img src={loadingIcon} alt="loading" width="120" height="120" />
                    </div>
                )
            }
            <div className="modal">
                <div className="modal-body modal-article-body">
                    <div className="text-center">
                        <p>
                            <b>Aviation Security Group</b>
                        </p>
                        <p>
                            <b>{politic.name}</b>
                        </p>
                    </div>
                    <br />
                    <div className="flex flex-column gap-4">
                        {
                            articleList.map(article => (
                                <div key={article.id} className="flex flex-column gap-4">
                                    <p className="text-center">
                                        <b>{article.name}</b>
                                    </p>
                                    <div
                                        className="flex flex-column gap-4 text-align"
                                        dangerouslySetInnerHTML={{ __html: article.description }}></div>
                                </div>
                            ))
                        }
                    </div>
                    <br />
                    <div className="flex justify-content-center" onClick={politic.visited ? onHandleAccept : saveUserPolitic}>
                        <button className="politic-button">
                            {politic.visited ? 'CERRAR' : 'ACEPTO HABER LEIDO EL PRESENTE DOCUMENTO'}
                        </button>
                    </div>
                </div>
            </div>
        </>
    )
}